import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '../App.vue';
import i18n from '@shared/i18n';
import { bootstrapModule } from '../core/bootstrap';
import { initAppConfig } from '../composables/use-app-config';
import { ensureUiConfigurationForLifecycle } from '@shared/config/ui-configuration-lifecycle';
import { runConfigBootstrapGate } from '@shared/config/bootstrap-gate';
import '@shared/styles/tokens-vars.css';

async function loadUiConfigForClients(): Promise<void> {
  await ensureUiConfigurationForLifecycle({
    endpoint: '/api/public/config',
    timeoutMs: 5000,
    maxAttempts: 3,
    backoffBaseMs: 250,
  });
  initAppConfig();
}

bootstrapModule('#app', (root) => {
  runConfigBootstrapGate({
    root,
    loadConfig: loadUiConfigForClients,
    mountApp: () => {
      const app = createApp(App);
      app.use(createPinia());
      app.use(i18n);
      app.mount(root);
    },
    loadingMessage: 'Validando configuración de cliente...',
    errorTitle: 'No se pudo iniciar la app cliente',
  });
}, { name: 'clients-base' });
